/**
 * Module-level impersonation state store.
 *
 * Shared between React (ImpersonationContext) and the Axios request
 * interceptor (apiClient.js).  Because this is a plain ES module the
 * state lives in memory only — a page refresh resets it, which is the
 * desired behaviour.
 */

const impersonationStore = {
  /** @type {'role'|'user'|null} */
  mode: null,

  /** Role override (mode === 'role') */
  role: null,

  /** Impersonated user id (mode === 'user') */
  userId: null,

  /** Display helpers (mode === 'user') */
  userName: null,
  userEmail: null,
  userRole: null,
};

export default impersonationStore;
